import { useCallback } from "react";

import {
  createFileRoute,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";

import { Route as OrderDetailsRoute } from "@app/navigation/routes/_private/orders/$id";
import { Route as OrderDocumentsRoute } from "@app/navigation/routes/_private/orders/documents";
import { tradeOrdersQueryOptions } from "@entities/orders/hooks/use-trade-orders";
import { tradeOrdersAssetsQueryOptions } from "@entities/orders/hooks/use-trade-orders-assets";
import { HistoryPageConnector } from "@pages/history";

export const Route = createFileRoute("/_private/transactions")({
  component: RouteComponent,
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(tradeOrdersAssetsQueryOptions()),
      context.queryClient.ensureInfiniteQueryData(
        tradeOrdersQueryOptions({ assets: [], statuses: [], types: [] }),
      ),
    ]);
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const router = useRouter();

  const handleGoToOrderDetails = useCallback(
    async (id: string) => {
      await navigate({
        params: { id },
        to: OrderDetailsRoute.fullPath,
      });
    },
    [navigate],
  );
  const getOrderHref = useCallback(
    (id: string) =>
      router.buildLocation({ params: { id }, to: OrderDetailsRoute.fullPath })
        .href,
    [router],
  );

  return (
    <HistoryPageConnector
      getOrderHref={getOrderHref}
      onExportDocuments={() => navigate({ to: OrderDocumentsRoute.fullPath })}
      onGoToOrderDetails={handleGoToOrderDetails}
    />
  );
}
